import { IgnorableException } from '@/modules/common/models/exception/ignorable-exception.ts';
import type { CommonError } from '@/modules/common/models/common-error.ts';

export class IgnorableApiException extends IgnorableException {
  constructor(error: unknown) {
    const apiError = error as CommonError;
    super(error, apiError.error_code, apiError.error_message);
  }
}
